import { Routes } from '@angular/router';
import { authGuard, loginRedirectGuard } from '@core/auth/auth.guard';
import { requireRole } from '@core/auth/role.guard';
import { Role } from '@core/auth/roles';

export const routes: Routes = [
  {
    path: 'login',
    canActivate: [loginRedirectGuard],
    loadComponent: () =>
      import('./features/auth/login/login.component').then((m) => m.LoginComponent),
  },
  {
    path: 'register',
    loadComponent: () =>
      import('./features/auth/register/register-placeholder.component').then(
        (m) => m.RegisterPlaceholderComponent,
      ),
  },
  {
    path: 'dashboard',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/dashboard/dashboard.component').then((m) => m.DashboardComponent),
  },
  {
    path: 'company',
    canActivate: [authGuard],
    loadChildren: () => import('./features/company/company.routes').then((m) => m.companyRoutes),
  },
  {
    path: 'customers',
    canActivate: [authGuard],
    loadChildren: () => import('./features/customer/customer.routes').then((m) => m.customerRoutes),
  },
  {
    path: 'waterbars',
    canActivate: [authGuard, requireRole(Role.SystemAdmin)],
    loadChildren: () => import('./features/waterbar/waterbar.routes').then((m) => m.waterbarRoutes),
  },
  {
    path: 'handyman',
    canActivate: [authGuard],
    loadChildren: () => import('./features/handyman/handyman.routes').then((m) => m.handymanRoutes),
  },
  {
    path: 'users',
    canActivate: [authGuard, requireRole(Role.SystemAdmin)],
    loadChildren: () => import('./features/users/user.routes').then((m) => m.userRoutes),
  },
  {
    path: 'sandbox',
    loadComponent: () =>
      import('./features/sandbox/sandbox.component').then((m) => m.SandboxComponent),
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'login',
  },
  {
    path: '**',
    redirectTo: 'login',
  },
];
